(() => {
  if (customElements.get('freshify-rotating-meals')) return;
  const smoothieWeeks = [
  [
    "strawberry-banana-protein",
    "west-coast-mango-coconut-protein",
    "pacific-berry-blast-protein",
    "chocolate-peanut-butter-protein",
    "banana-cream-protein",
    "avocado-vanilla-protein"
  ],
  [
    "acai-berry-protein",
    "pineapple-coconut-protein",
    "coffee-mocha-protein",
    "pb-j-protein-smoothie",
    "matcha-green-protein",
    "blueberry-vanilla-protein"
  ],
  [
    "cookies-cream-protein",
    "chocolate-banana-recovery",
    "mango-tropical-protein",
    "salted-caramel-protein",
    "chocolate-espresso-protein",
    "mixed-berry-recovery"
  ]
];
  const cycle = (date = new Date()) => {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Vancouver',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
    const part = name => Number(parts.find(p => p.type === name).value);
    const today = Date.UTC(part('year'), part('month') - 1, part('day'));
    const anchor = Date.UTC(2026, 9, 12);
    const elapsed = Math.max(0, Math.floor((today - anchor) / 604800000));
    return {index:elapsed % 6, start:new Date(anchor + elapsed * 604800000).toISOString().slice(0,10)};
  };
  class RotatingMeals extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true; this.week = cycle();
      if (this.dataset.menuType === 'smoothies') {
        const handles = smoothieWeeks[this.week.index % smoothieWeeks.length];
        this.querySelectorAll('[data-item-handle]').forEach(card => { card.hidden = !handles.includes(card.dataset.itemHandle); });
      }
      const weekLabel = `${this.dataset.weekPrefix} ${this.week.index + 1}`;
      this.querySelector('[data-meal-week]').textContent = weekLabel;
      this.querySelectorAll('.frm-form').forEach(form => {
        form.querySelector('[data-order-week]').value = weekLabel;
        form.querySelector('[data-order-monday]').value = this.week.start;
        const price = () => {
          const select = form.querySelector('select[name="id"]');
          const variant = select.options[select.selectedIndex];
          const quantity = Number(form.querySelector('[name="quantity"]').value);
          const cents = Number(variant?.dataset.price);
          form.querySelector('[data-item-total]').textContent = quantity > 0 && Number.isInteger(quantity) && Number.isFinite(cents) ? new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency', currency:this.dataset.currency || 'CAD'}).format(cents * quantity / 100) : '';
        };
        form.addEventListener('change', price); form.addEventListener('input', price); price();
        form.addEventListener('submit', event => { event.preventDefault(); this.add(form); });
      });
      this.timer = setInterval(() => {
        if (cycle().start !== this.week.start) {
          this.expired = true;
          this.querySelectorAll('.frm-form').forEach(form => {form.querySelector('button[type="submit"]').disabled=true;form.querySelector('[data-item-status]').textContent=this.dataset.expired;});
        }
      }, 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    payload(form) {
      const quantity = Number(form.querySelector('[name="quantity"]').value);
      const select = form.querySelector('select[name="id"]');
      const option = select.options[select.selectedIndex];
      if (!Number.isInteger(quantity) || quantity < 1 || !option || option.disabled || !form.querySelector('input[type="checkbox"]').checked) return null;
      return {items:[{id:Number(option.value),quantity,properties:{'Menu week':form.querySelector('[data-order-week]').value,'Menu starting Monday':this.week.start,'Allergen disclaimer':'Reviewed'}}],sections:['cart-icon-bubble'],sections_url:window.location.pathname};
    }
    async add(form) {
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled || this.expired || form.closest('[data-item-handle]').hidden || !form.reportValidity()) return;
      const payload = this.payload(form); if (!payload) return;
      const status = form.querySelector('[data-item-status]');
      button.disabled = true; status.textContent = this.dataset.adding;
      try {
        const response = await fetch(`${this.dataset.cartRoot || '/'}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || this.dataset.error);
        status.textContent = this.dataset.added;
        if (result.sections?.['cart-icon-bubble']) {
          const fragment = new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = (fragment.getElementById('cart-icon-bubble') || fragment.querySelector('.shopify-section') || fragment.body).innerHTML;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', {detail:{source:'rotating-meals'}}));
      } catch(error) {status.textContent = error.message || this.dataset.error;}
      finally {button.disabled = Boolean(this.expired);}
    }
  }
  customElements.define('freshify-rotating-meals', RotatingMeals);
})();
